import { c as _c } from "react/compiler-runtime";
import { ArticleGrid } from "@/views/home/partials/articles/ArticleGrid";
import type { Post } from "@/payload-types";
interface NewsGridProps {
  articles: Post[];
  title: string;
}

/**
 * 3-column news grid at the bottom of the hub — uses the site's `ArticleGrid`
 * component, same layout as the homepage's "more news" block.
 */
export function NewsGrid(t0) {
  const $ = _c(3);
  const {
    articles,
    title
  } = t0;
  if (articles.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== articles || $[1] !== title) {
    t1 = <ArticleGrid articles={articles} title={title} columns={3} />;
    $[0] = articles;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}